import * as React from 'react'

function CircleShare(props) {
  return (
    <svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 90 90"
      {...props}
    >
      <path
        d="M45 90C20.147 90 0 69.853 0 45v0C0 20.147 20.147 0 45 0h0c24.853 0 45 20.147 45 45v0c0 24.853-20.147 45-45 45z"
        fill="#E1306C"
      />
      <path
        d="M45 22L57 34M45 22L33 34M45 22V56M27 44V62H63V44"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CircleShare
